module.exports = __webpack_public_path__ + "static/media/recent-before.dcc72c01.png";